<template>
  <nav class="navbar">
    <div class="search-container">
      <SearchBar @search="handleSearch" />
    </div>
  </nav>
</template>

<script>
import SearchBar from './SearchBar.vue';

export default {
  name: 'NavbarComponent',
  components: {
    SearchBar,
  },
  methods: {
    handleSearch(query) {
      this.$emit('search', query);
    },
  },
};
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.search-container {
  flex-grow: 1;
  max-width: 600px;
}
</style>
